import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

export const ExploreZoomBlurRecording20261028Composition = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(364 / 60) * fps}
			style={{
				width: 2896,
				height: 1842,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/zoom-blur-recording-2026-10-28-7bce6523c0db.mp4"
				muted
				durationInFrames={(364 / 60) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[9, 14, 15, 100, 101, 127, 128, 289, 290],
					[
						'auto',
						'default',
						'auto',
						'ew-resize',
						'auto',
						'custom',
						'auto',
						'ew-resize',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={
					'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize'
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 46, 124, 319, 324],
						[3.5, 3.15, 3.5, 3.15, 3.5],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							9, 10, 11, 12, 13, 14, 15, 16, 22, 23, 24, 25, 26, 27, 28, 29, 30,
							31, 32, 33, 35, 36, 37, 38, 39, 40, 41, 42, 43, 45, 46, 51, 52,
							53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68,
							69, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86,
							87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 117, 118, 120, 121, 122, 123, 124, 125, 126, 127,
							128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140,
							141, 142, 143, 144, 156, 157, 158, 159, 160, 177, 178, 179, 180,
							181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 218,
							219, 220, 221, 222, 264, 265, 266, 267, 268, 269, 270, 271, 273,
							274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286,
							287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299,
							300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312,
							313, 314, 318, 319,
						],
						[
							'2386.111328125px 3920.505859375px',
							'2386.111328125px 3920.505859375px',
							'2909.51171875px 3306.091796875px',
							'3326.1484375px 2798.25px',
							'3458.7109375px 2538.89453125px',
							'3484.578125px 2391.23828125px',
							'3492.3984375px 2300.361328125px',
							'3492.75390625px 2289.984375px',
							'3492.75390625px 2289.984375px',
							'3492.75390625px 2289.423828125px',
							'3492.75390625px 2282.751953125px',
							'3492.75390625px 2282.751953125px',
							'3492.3984375px 2280.919921875px',
							'3492.3984375px 2280.919921875px',
							'3492.34375px 2266.1953125px',
							'3493.369140625px 2235.556640625px',
							'3493.861328125px 2214.748046875px',
							'3493.423828125px 2210.93359375px',
							'3493.095703125px 2209.62109375px',
							'3492.86328125px 2208.814453125px',
							'3492.86328125px 2208.814453125px',
							'3492.37109375px 2208.814453125px',
							'3489.609375px 2208.814453125px',
							'3478.80859375px 2208.814453125px',
							'3459.88671875px 2209.40234375px',
							'3423.4375px 2211.234375px',
							'3398.9921875px 2211.986328125px',
							'3392.580078125px 2212.1640625px',
							'3391.623046875px 2212.1640625px',
							'3391.623046875px 2212.1640625px',
							'3391.103515625px 2212.1640625px',
							'3391.103515625px 2212.1640625px',
							'3389.462890625px 2212.1640625px',
							'3320.98046875px 2213.544921875px',
							'3209.71875px 2216.9765625px',
							'3166.10546875px 2217.82421875px',
							'3037.767578125px 2221.501953125px',
							'2967.767578125px 2222.349609375px',
							'2883.904296875px 2220.927734375px',
							'2781.0234375px 2218.31640625px',
							'2781.0234375px 2218.31640625px',
							'2685.607421875px 2217.8515625px',
							'2667.24609375px 2218.357421875px',
							'2650.716796875px 2218.384765625px',
							'2638.822265625px 2218.849609375px',
							'2625.73828125px 2218.849609375px',
							'2607.951171875px 2219.068359375px',
							'2596.466796875px 2219.615234375px',
							'2587.169921875px 2219.833984375px',
							'2583.84765625px 2219.833984375px',
							'2583.84765625px 2219.833984375px',
							'2583.30078125px 2219.833984375px',
							'2571.912109375px 2220.107421875px',
							'2543.70703125px 2221.091796875px',
							'2526.26171875px 2221.48828125px',
							'2514.96875px 2221.48828125px',
							'2507.99609375px 2221.48828125px',
							'2467.896484375px 2222.923828125px',
							'2450.62890625px 2223.087890625px',
							'2423.298828125px 2223.935546875px',
							'2408.68359375px 2224.5234375px',
							'2397.25390625px 2224.974609375px',
							'2387.21875px 2224.974609375px',
							'2380.13671875px 2224.974609375px',
							'2370.607421875px 2225.302734375px',
							'2358.931640625px 2225.58984375px',
							'2352.095703125px 2225.58984375px',
							'2346.927734375px 2225.58984375px',
							'2340.994140625px 2225.58984375px',
							'2332.298828125px 2225.671875px',
							'2323.712890625px 2226.123046875px',
							'2317.533203125px 2226.123046875px',
							'2313.486328125px 2226.287109375px',
							'2305.146484375px 2226.888671875px',
							'2301.359375px 2227.12109375px',
							'2286.1015625px 2229.69140625px',
							'2280.837890625px 2230.416015625px',
							'2277.720703125px 2230.7578125px',
							'2273.181640625px 2231.6875px',
							'2265.552734375px 2233.02734375px',
							'2257.240234375px 2234.544921875px',
							'2252.359375px 2235.310546875px',
							'2250.568359375px 2235.65234375px',
							'2250.03515625px 2235.734375px',
							'2250.03515625px 2235.734375px',
							'2250.03515625px 2236.2265625px',
							'2250.03515625px 2236.2265625px',
							'2250.240234375px 2236.431640625px',
							'2250.74609375px 2236.9375px',
							'2252.263671875px 2238.455078125px',
							'2254.6015625px 2247.013671875px',
							'2254.6015625px 2264.677734375px',
							'2245.60546875px 2310.095703125px',
							'2217.796875px 2371.49609375px',
							'2147.591796875px 2499.46484375px',
							'2067.392578125px 2648.775390625px',
							'1983.529296875px 2809.419921875px',
							'1877.421875px 3013.431640625px',
							'1807.23046875px 3152.0234375px',
							'1759.255859375px 3259.880859375px',
							'1750.109375px 3281.072265625px',
							'1719.40234375px 3356.08984375px',
							'1709.203125px 3375.845703125px',
							'1708.13671875px 3378.3203125px',
							'1704.595703125px 3386.783203125px',
							'1703.337890625px 3389.44921875px',
							'1701.7109375px 3392.224609375px',
							'1699.33203125px 3396.01171875px',
							'1698.033203125px 3398.951171875px',
							'1697.568359375px 3399.962890625px',
							'1697.52734375px 3400.03125px',
							'1697.52734375px 3400.03125px',
							'1656.498046875px 3439.994140625px',
							'1611.626953125px 3489.4453125px',
							'1593.2109375px 3531.2265625px',
							'1591.119140625px 3539.771484375px',
							'1591.119140625px 3539.771484375px',
							'1591.119140625px 3544.255859375px',
							'1597.50390625px 3550.873046875px',
							'1603.478515625px 3552.076171875px',
							'1603.423828125px 3551.734375px',
							'1600.4296875px 3549.697265625px',
							'1598.2421875px 3549.123046875px',
							'1593.990234375px 3547.947265625px',
							'1588.78125px 3546.1015625px',
							'1586.375px 3545.171875px',
							'1583.859375px 3544.091796875px',
							'1581.904296875px 3543.626953125px',
							'1579.115234375px 3542.875px',
							'1577.037109375px 3542.51953125px',
							'1577.037109375px 3542.51953125px',
							'1576.599609375px 3542.51953125px',
							'1576.599609375px 3542.51953125px',
							'1573.55078125px 3542.79296875px',
							'1549.7890625px 3544.84375px',
							'1514.775390625px 3546.78515625px',
							'1508.103515625px 3546.78515625px',
							'1508.103515625px 3546.78515625px',
							'1508.3359375px 3546.78515625px',
							'1535.1875px 3549.65625px',
							'1610.505859375px 3575.16796875px',
							'1645.02734375px 3595.2109375px',
							'1687.30078125px 3642.98046875px',
							'1687.30078125px 3642.98046875px',
							'1795.36328125px 3792.6875px',
							'1795.36328125px 3792.6875px',
							'1825.017578125px 3884.767578125px',
							'1826.37109375px 3897.359375px',
							'1826.37109375px 3897.359375px',
							'1835.982421875px 3918.5234375px',
							'1845.990234375px 3934.806640625px',
							'1860.974609375px 3953.82421875px',
							'1895.154296875px 3990.24609375px',
							'1935.185546875px 4023.27734375px',
							'1992.2109375px 4051.49609375px',
							'2054.08984375px 4075.2578125px',
							'2109.693359375px 4088.013671875px',
							'2173.6640625px 4095.4921875px',
							'2208.021484375px 4096.380859375px',
							'2235.283203125px 4095.642578125px',
							'2262.6953125px 4092.251953125px',
							'2274.330078125px 4090.1328125px',
							'2280.318359375px 4087.9453125px',
							'2282.396484375px 4086.701171875px',
							'2284.146484375px 4085.3203125px',
							'2284.802734375px 4084.650390625px',
							'2285.390625px 4084.048828125px',
							'2288.357421875px 4082.681640625px',
							'2293.59375px 4080.576171875px',
							'2297.33984375px 4079.7421875px',
							'2304.3125px 4078.59375px',
							'2315.3046875px 4077.267578125px',
							'2328.73046875px 4075.572265625px',
							'2343.126953125px 4073.1796875px',
							'2350.837890625px 4071.62109375px',
							'2354.296875px 4070.63671875px',
							'2358.685546875px 4069.310546875px',
							'2361.419921875px 4068.01171875px',
							'2364.017578125px 4066.15234375px',
							'2365.1796875px 4065.25px',
							'2367.3671875px 4063.71875px',
							'2369.69140625px 4062.392578125px',
							'2372.384765625px 4060.505859375px',
							'2375.912109375px 4058.181640625px',
							'2378.3046875px 4056.390625px',
							'2380px 4055.009765625px',
							'2380.150390625px 4054.873046875px',
							'2380.150390625px 4054.873046875px',
							'2380.150390625px 4054.517578125px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
